import { Component } from '@angular/core';

@Component({
    selector: 'ols-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
    constructor() {}
}
